"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewDcRetryPayment extends new_item_1.default {
    constructor(newDcRetryPayment) {
        super();
        this.status = newDcRetryPayment.status;
    }
}
exports.default = NewDcRetryPayment;
//# sourceMappingURL=new-dcRetryPayment.js.map